<div
    *ngIf="{
        installationTooltipText: installationTooltipText$ | async
    } as viewStates">
    <div class="mt-1 mb-0 fw-bold">
        <wa-cms-content
            cmsKey="cart:addon:title_installation"></wa-cms-content>
    </div>
    <div *ngFor="let addon of addons">
        <div
            class="d-flex justify-content-between mt-3"
            [attr.data-eid]="createAddonSelector(addon)">
            <div class="d-flex justify-content-start">
                <input
                    [disabled]="isUpdatingCart || isDisabled(addon)"
                    [name]="addon.name"
                    [id]="addon.service_id"
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isAddonSelected(addon)"
                    (change)="toggleCartItemAddon(addon)" />
                <label class="form-check-label d-block ps-2">
                    {{ addon.name | titlecase }}
                </label>
            </div>
            <div>
                <span>{{ getAddonPrice(addon) | currency }}</span>
            </div>
        </div>
        <div *ngIf="this.isInstallationAddon(addon)" class="mt-3 ps-4">
            <div
                *ngFor="let requiredAccessory of requiredAccessories"
                class="d-flex justify-content-between align-items-start"
                data-eid="addon-tootip">
                <div
                    class="d-flex"
                    placement="bottom"
                    triggers="hover"
                    [autoClose]="true"
                    [ngbTooltip]="viewStates.installationTooltipText"
                    data-eid="required-accessories-text-tooltip"
                    tooltipClass="tooltip">
                    <input
                        [disabled]="true"
                        [name]="requiredAccessory.name"
                        [id]="requiredAccessory.sku"
                        type="checkbox"
                        class="form-check-input"
                        [checked]="isInstallationChosen" />
                    <label class="form-check-label d-block ps-2 text-muted">
                        {{ requiredAccessory.name | titlecase }}
                    </label>
                </div>
                <span class="text-muted">{{
                    getRequiredAccessoryPrice(addon, requiredAccessory)
                        | currency
                }}</span>
            </div>
        </div>
    </div>
</div>
